import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import TerminalPage from './pages/TerminalPage'


const LANGUAGES = {
    pt: {
        urlLang: 'pt',
        code: 'pt-BR'
    },
    en: {
        urlLang: 'en',
        code: 'en-US'
    }
}

const MultiLanguageRoute = (props) => {
    const defaultLanguage = LANGUAGES.en.urlLang
    const hasLang = props.computedMatch.params.lang
    const is404Page = props.path
    const isBasePathWithoutLang = props.path === "/"

    if(isBasePathWithoutLang)  return  <Redirect to={`/${defaultLanguage}`} />
    if(!hasLang && !is404Page) return <Redirect to={`/${defaultLanguage}`} />

    return <Route {...props} />    
}

const Routes = () => {
    return (
        <Switch>
          <MultiLanguageRoute path="/" exact/>
          <MultiLanguageRoute path="/:lang" exact component={TerminalPage}></MultiLanguageRoute>
          <MultiLanguageRoute path="/:lang/:page(about|projects|contact)" exact component={TerminalPage}></MultiLanguageRoute>
        </Switch>
    )
}

export default Routes
